import { render, staticRenderFns } from "./PensionContractDetails.vue?vue&type=template&id=56f64873&scoped=true&"
import script from "./PensionContractDetails.vue?vue&type=script&lang=ts&"
export * from "./PensionContractDetails.vue?vue&type=script&lang=ts&"
import style0 from "./PensionContractDetails.vue?vue&type=style&index=0&id=56f64873&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f64873",
  null
  
)

export default component.exports